import React from 'react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Terms of Service - Trademark Flare"
        description="Review Trademark Flare's terms of service for our Canadian trademark registration and intellectual property services. Understand your rights and responsibilities."
        keywords="terms of service, service agreement, trademark flare terms, legal terms"
      />
      <section className="pt-24 pb-16 bg-gradient-to-br from-brand-600 to-brand-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-4 text-center">
            Terms of Service
          </h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing and using Trademark Flare's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Our Services</h2>
            <p className="text-gray-600 mb-6">
              Trademark Flare provides trademark registration services, copyright registration, trademark searches, company formation, and Amazon Brand Registry support for Canadian businesses. We act as agents to facilitate applications with the Canadian Intellectual Property Office (CIPO) and other relevant authorities.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Service Fees and Payment</h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">Our Fees</h3>
            <p className="text-gray-600 mb-6">
              Our service fees are clearly outlined in our pricing packages. These fees cover our professional services, consultation, application preparation, and filing support.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">Government Fees</h3>
            <p className="text-gray-600 mb-6">
              Government filing fees charged by CIPO are separate from our service fees and are paid directly to the relevant government office. These fees are subject to change by the government without notice.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">Payment Terms</h3>
            <p className="text-gray-600 mb-6">
              Payment for our services is required before we begin work on your application. We accept various payment methods as indicated on our website. All fees are in Canadian dollars unless otherwise specified.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Client Responsibilities</h2>
            <p className="text-gray-600 mb-4">As a client, you agree to:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Provide accurate and complete information for your applications</li>
              <li>Respond promptly to requests for additional information</li>
              <li>Review all documents and applications before submission</li>
              <li>Comply with all applicable laws and CIPO requirements</li>
              <li>Maintain confidentiality of any login credentials provided</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">No Guarantee of Approval</h2>
            <p className="text-gray-600 mb-6">
              While we use our expertise to maximize the chances of approval, we cannot guarantee that CIPO or any government office will approve your trademark or other applications. Approval decisions are made solely by the relevant government authorities. Our service fees are for professional services rendered and are non-refundable regardless of application outcome.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              The content, design, and functionality of our website are owned by Trademark Flare and protected by Canadian and international copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our explicit written permission.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              To the maximum extent permitted by law, Trademark Flare shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Confidentiality</h2>
            <p className="text-gray-600 mb-6">
              We maintain strict confidentiality of all client information and trademark applications. However, certain information must be disclosed to CIPO and becomes part of the public record upon trademark registration.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Termination</h2>
            <p className="text-gray-600 mb-6">
              Either party may terminate the service agreement with written notice. Upon termination, you remain responsible for any fees incurred up to the termination date. We will provide you with all work completed and documentation in our possession.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Governing Law</h2>
            <p className="text-gray-600 mb-6">
              These Terms of Service shall be governed by and construed in accordance with the laws of the Province of Nova Scotia and the federal laws of Canada applicable therein. Any disputes shall be subject to the exclusive jurisdiction of the courts of Nova Scotia.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Changes to Terms</h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Contact Information</h2>
            <p className="text-gray-600 mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-brand-50 rounded-lg p-6 mb-6">
              <p className="text-gray-700"><strong>Email:</strong> <a href="mailto:info@trademarkflare.com" className="">info@trademarkflare.com</a></p>
              <p className="text-gray-700"><strong>Phone:</strong> <a href="tel:+18669788034" className="text-gray-700">+1 (866) 978-8034</a></p>
              <p className="text-gray-700"><strong>Address:</strong> 6156 Quinpool Rd, Halifax, NS B3L 1A3, Canada</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
